import { useCallback, useEffect, useMemo } from 'react'
import { useReactiveVar } from '@apollo/client'
import { useNavigate } from 'react-router-dom'

import {
  activeProjectVar,
  currentUserVar,
  labelCodeIdVar,
  labelCodeVar,
  labelTitleVar,
  notificationMessageVar
} from 'modulesCommon/store'
import { usePrevious } from 'shared/hooks'
import { useZonesList } from 'modulesCommon/serviceHooks'
import { Label } from 'shared/__gql-types'

export const useSwitchToProjectZone = () => {
  const navigate = useNavigate()

  const currentUser = useReactiveVar(currentUserVar)
  const activeProject = useReactiveVar(activeProjectVar)
  const currentLabelId = useReactiveVar(labelCodeIdVar)
  const prevActiveProject = usePrevious(activeProject)
  const { zoneList } = useZonesList()

  const redirectToProject = useCallback(
    (labelId?: string) => {
      const isNotProjectZone = activeProject?.id && labelId !== `${activeProject.label_id}`

      if (isNotProjectZone) {
        navigate('/projects')
      }
    },
    [navigate, activeProject]
  )

  const switchedLabel = useMemo(
    () => zoneList.find((label: Label) => label.id === `${activeProject?.label_id}`),
    [zoneList, activeProject?.label_id]
  )

  const switchToProjectLabel = useCallback((label) => {
    labelCodeIdVar(label.id)
    labelTitleVar(label.name)
    labelCodeVar(label.alias)
  }, [])

  useEffect(() => {
    const isFirstOpenCampaign = activeProject?.id && prevActiveProject?.id !== activeProject.id

    if (
      switchedLabel &&
      isFirstOpenCampaign &&
      currentUser?.label_id !== `${activeProject.label_id}` &&
      currentLabelId !== `${activeProject.label_id}`
    ) {
      notificationMessageVar({
        message: `This Project is part of ${switchedLabel?.alias || ''} Zone.`,
        title: '',
        type: 'warning',
        containerStyle: 'solid'
      })
      switchToProjectLabel(switchedLabel)
    }
  }, [currentUser, activeProject, prevActiveProject, currentLabelId, switchedLabel, switchToProjectLabel])

  return {
    switchedLabelName: switchedLabel?.alias || '',
    redirectToProject
  }
}
